import type { CheckoutPhase } from '../types';

const PHASE_BY_EVENT: Readonly<Record<string, CheckoutPhase>> = {
  'checkout.loaded': 'ready',
  'checkout.payment.initiated': 'processing',
  'checkout.payment.failed': 'declined',
  'checkout.error': 'declined',
  'checkout.completed': 'completed',
  'checkout.closed': 'idle',
};

/** The checkout phase a Paddle.js event moves to, or null for events that change nothing here. */
export const phaseForPaddleEvent = (name: string | undefined): CheckoutPhase | null =>
  (name ? PHASE_BY_EVENT[name] : undefined) ?? null;
